export function isRecord(input: unknown): input is Record<string, unknown> {
  return typeof input === 'object' && input !== null;
}

export function isStringArray(input: unknown): input is string[] {
  return Array.isArray(input) && input.every((value) => typeof value === 'string');
}

export type CompareDataDTOBase = {
  version: string;
  workspaceName: string;
  projectIdentifier: string;
};

type CompareDataDTOBaseShape = CompareDataDTOBase & Record<string, unknown>;

export function isCompareDataDTOBaseShape(input: unknown): input is CompareDataDTOBaseShape {
  return (
    isRecord(input) &&
    typeof input.version === 'string' &&
    typeof input.workspaceName === 'string' &&
    typeof input.projectIdentifier === 'string'
  );
}
